import { render, staticRenderFns } from "./SetupSection.vue?vue&type=template&id=26ff6e1c"
import script from "./SetupSection.vue?vue&type=script&lang=js"
export * from "./SetupSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports